import type { Scene } from './scenes';
import { MORE_PLACES } from './places/index';

const kitchen: Scene = {
  id: 'kitchen',
  label: 'Kitchen',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="210" fill="#f4ecdc" />
      <rect y="210" width="400" height="90" fill="#d9c3a0" />
      <g stroke="#cbb48c" strokeWidth="1.5">{[230, 252, 274].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}</g>
      <rect x="0" y="150" width="250" height="12" fill="#b98a5c" />
      <rect x="0" y="162" width="250" height="60" fill="#e8dcc6" stroke="#c9b48f" strokeWidth="2" />
      <g fill="none" stroke="#c9b48f" strokeWidth="2">
        <line x1="62" y1="162" x2="62" y2="222" />
        <line x1="124" y1="162" x2="124" y2="222" />
        <line x1="186" y1="162" x2="186" y2="222" />
      </g>
      <g fill="#a98a62">{[52, 72, 114, 134, 176, 196].map((x) => <rect key={x} x={x - 3} y="182" width="6" height="14" rx="2" />)}</g>
      <rect x="0" y="40" width="96" height="62" fill="#e8dcc6" stroke="#c9b48f" strokeWidth="2" />
      <line x1="48" y1="40" x2="48" y2="102" stroke="#c9b48f" strokeWidth="2" />
    </>
  ),
  parts: [
    {
      id: 'window', label: 'window', at: [168, 72], box: [124, 30, 88, 84], art: (
        <g>
          <rect x="126" y="32" width="84" height="80" rx="3" fill="#cfe8f7" stroke="#b98a5c" strokeWidth="5" />
          <line x1="168" y1="32" x2="168" y2="112" stroke="#b98a5c" strokeWidth="4" />
          <line x1="126" y1="72" x2="210" y2="72" stroke="#b98a5c" strokeWidth="4" />
        </g>
      ),
    },
    {
      id: 'clock', label: 'clock', at: [254, 56], box: [232, 34, 44, 44], art: (
        <g>
          <circle cx="254" cy="56" r="20" fill="#fffdf6" stroke="#3a3a3a" strokeWidth="3" />
          <line x1="254" y1="56" x2="254" y2="43" stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />
          <line x1="254" y1="56" x2="264" y2="60" stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />
        </g>
      ),
    },
    {
      id: 'fridge', label: 'fridge', at: [370, 140], box: [338, 60, 62, 162], art: (
        <g>
          <rect x="340" y="62" width="58" height="158" rx="6" fill="#eef2f5" stroke="#9fb0c2" strokeWidth="3" />
          <line x1="340" y1="118" x2="398" y2="118" stroke="#9fb0c2" strokeWidth="3" />
          <rect x="346" y="80" width="5" height="26" rx="2" fill="#9fb0c2" />
          <rect x="346" y="128" width="5" height="34" rx="2" fill="#9fb0c2" />
        </g>
      ),
    },
    {
      id: 'tap', label: 'tap', at: [168, 136], box: [152, 118, 32, 34], art: (
        <g fill="none" stroke="#8a96a3" strokeWidth="5" strokeLinecap="round">
          <path d="M160 150 L160 126 Q160 120 168 120 L176 120 Q182 120 182 128" />
        </g>
      ),
    },
    {
      id: 'kettle', label: 'kettle', at: [40, 132], box: [16, 108, 52, 44], art: (
        <g>
          <path d="M22 150 L26 118 Q40 110 54 118 L58 150 Z" fill="#d8473b" stroke="#a83a31" strokeWidth="2" />
          <path d="M56 124 Q68 126 66 138 L58 140" fill="none" stroke="#a83a31" strokeWidth="4" />
          <path d="M24 122 L14 116" stroke="#a83a31" strokeWidth="4" strokeLinecap="round" />
          <rect x="34" y="110" width="12" height="5" rx="2" fill="#a83a31" />
        </g>
      ),
    },
    {
      id: 'cup', label: 'cup', at: [96, 140], box: [80, 124, 34, 28], art: (
        <g>
          <path d="M84 128 L106 128 L104 150 L86 150 Z" fill="#2f74c8" stroke="#22558f" strokeWidth="2" />
          <path d="M106 132 Q114 134 112 142 L104 144" fill="none" stroke="#22558f" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'bowl', label: 'fruit bowl', at: [222, 136], box: [194, 116, 56, 36], art: (
        <g>
          <circle cx="212" cy="132" r="9" fill="#d8473b" />
          <circle cx="228" cy="128" r="9" fill="#3f9a45" />
          <path d="M218 126 Q236 116 244 132" fill="#f2c230" />
          <path d="M196 136 L248 136 Q244 152 222 152 Q200 152 196 136 Z" fill="#e8dcc6" stroke="#b98a5c" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'table', label: 'table', at: [150, 236], box: [100, 222, 130, 70], art: (
        <g>
          <rect x="100" y="230" width="130" height="10" rx="3" fill="#a8713f" />
          <rect x="108" y="240" width="8" height="52" fill="#8a5a33" />
          <rect x="214" y="240" width="8" height="52" fill="#8a5a33" />
        </g>
      ),
    },
    {
      id: 'plate', label: 'plate', at: [140, 224], box: [118, 214, 46, 18], art: (
        <ellipse cx="140" cy="226" rx="20" ry="6" fill="#ffffff" stroke="#c9c2b4" strokeWidth="2" />
      ),
    },
    {
      id: 'spoon', label: 'spoon', at: [196, 224], box: [180, 214, 38, 18], art: (
        <g>
          <line x1="184" y1="228" x2="204" y2="222" stroke="#8a96a3" strokeWidth="3" strokeLinecap="round" />
          <ellipse cx="208" cy="221" rx="6" ry="4" fill="#9aa3ad" />
        </g>
      ),
    },
    {
      id: 'chair', label: 'chair', at: [276, 240], box: [252, 176, 50, 118], art: (
        <g fill="#3f9a45" stroke="#2c7a33" strokeWidth="2">
          <rect x="282" y="180" width="8" height="70" rx="2" />
          <rect x="256" y="244" width="40" height="8" rx="2" />
          <rect x="258" y="252" width="6" height="40" />
          <rect x="288" y="252" width="6" height="40" />
        </g>
      ),
    },
    {
      id: 'bin', label: 'bin', at: [330, 262], box: [314, 232, 36, 60], art: (
        <g>
          <rect x="318" y="244" width="28" height="46" rx="3" fill="#7f8b96" stroke="#5c6670" strokeWidth="2" />
          <rect x="314" y="236" width="36" height="9" rx="3" fill="#5c6670" />
        </g>
      ),
    },
  ],
};

export const PLACES: Scene[] = [kitchen, ...MORE_PLACES];
